module.exports = __webpack_public_path__ + "static/media/pdf-download.5879dfd8.svg";